module.exports = __webpack_public_path__ + "img/team-worked-6.791cfe24.png";